export function CapitalizeFilter() {
  'use strict'

  return (token) => {
    return token.charAt(0).toUpperCase() + token.slice(1)
  }
}
